/* ═══════════════════════════════════════════════════════════════
   HERBAL CUP TEA — Subscribe & Save Page Script
   Subscribe FAQ accordion (single-open: opening one closes others).
   Event-delegated so it works regardless of script load timing.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.sub-faq__trigger');
    if (!trigger) return;

    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId && document.getElementById(panelId);
    if (!panel) return;

    var willOpen = trigger.getAttribute('aria-expanded') !== 'true';

    // Close all other sub-faq items (single-open behavior)
    document.querySelectorAll('.sub-faq__trigger').forEach(function (other) {
      if (other === trigger) return;
      other.setAttribute('aria-expanded', 'false');
      var otherPanelId = other.getAttribute('aria-controls');
      var otherPanel = otherPanelId && document.getElementById(otherPanelId);
      if (otherPanel) otherPanel.setAttribute('hidden', '');
    });

    trigger.setAttribute('aria-expanded', String(willOpen));
    if (willOpen) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });
})();
